import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default [
  {
    path: '/',
    redirect: 'alerta',
    component: LayoutPadrao,
    children: [
      {
        path: '/alerta',
        name: 'alerta',
        component: () => import('./pages/listarAlerta.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'alerta',
    component: LayoutPadrao,
    children: [
      {
        path: '/alerta/:id',
        name: 'alerta-editar',
        component: () => import('./pages/editarAlerta.vue')
      }
    ]
  }
]



